import React from "react";
import moment from "moment";
import { Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell } from "@sainsburys-tech/fable";
import PropTypes from "prop-types";
import OverrideStageIcon from "../OverrideStageIcon";

const StoreOverridesTable = props => (
  <div>
    <h4 className="fable:pt-4">Overrides</h4>
    {props.data.length > 0 ? (
      <Table isResponsive={true} layout="fixed">
        <TableHeader>
          <TableRow>
            <TableHeaderCell className="cb-c-overrides-list__overrides-table__name-column">Name</TableHeaderCell>
            <TableHeaderCell className="cb-c-overrides-list__overrides-table__storename-column">Zone(s)</TableHeaderCell>
            <TableHeaderCell className="cb-c-overrides-list__overrides-table__date-time-column">Start time & date</TableHeaderCell>
            <TableHeaderCell className="cb-c-overrides-list__overrides-table__date-time-column">End time & date</TableHeaderCell>
            <TableHeaderCell className="cb-c-overrides-list__overrides-table__date-time-column">Last updated</TableHeaderCell>
            <TableHeaderCell>Status</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {props.data.map((override, index) => (
            <TableRow key={index}>
              <TableCell className="cb-c-overrides-list__overrides-table__name-column">{override.overrideName}</TableCell>
              <TableCell className="cb-c-overrides-list__overrides-table__storename-column">{override.zones}</TableCell>
              <TableCell className="cb-c-overrides-list__overrides-table__date-time-column">
                {new moment(override.start).format("HH:mm")} - {new moment(override.start).format("DD/MM/YY")}
              </TableCell>
              <TableCell className="cb-c-overrides-list__overrides-table__date-time-column">
                {new moment(override.end).format("HH:mm")} - {new moment(override.end).format("DD/MM/YY")}
              </TableCell>
              <TableCell className="cb-c-overrides-list__overrides-table__date-time-column">
                {moment(override.created).format("DD/MM/YY")}
              </TableCell>
              <TableCell>
                <span className="fable:flex fable:items-center">
                  <span className="fable:mr-2">
                    <OverrideStageIcon stage={override.stage.stage.description} />
                  </span>
                  {override.stage.stage.description}
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    ) : (
      <div>There are currently no overrides for this store.</div>
    )}
  </div>
);

StoreOverridesTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      overrideName: PropTypes.string,
      store: PropTypes.string,
      zones: PropTypes.string,
      start: PropTypes.Date,
      end: PropTypes.Date,
      stage: PropTypes.shape({
        storeId: PropTypes.string,
        stage: PropTypes.shape({
          name: PropTypes.string,
          description: PropTypes.string
        })
      }),
      created: PropTypes.Date
    })
  )
};
export default StoreOverridesTable;
